export default __webpack_public_path__ + "static/media/codepen.ce685477.png";